import Icon from '@ant-design/icons';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import type { ComponentProps } from 'react';

/**
 * Toolbar glyph for the "build route" tool — side-view car silhouette
 * from Material Symbols `directions_car` (Apache-2.0). Everything is a
 * single path filled with `currentColor`; the windscreen subpath acts
 * as an evenodd-hole so the button background shows through it. This
 * way the glyph stays readable on every Ant Design button state
 * (primary → white silhouette with blue window; default → dark
 * silhouette with light window).
 */
function CarSvg(props: Partial<CustomIconComponentProps>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"
      />
    </svg>
  );
}

export default function CarGlyph(props: ComponentProps<typeof Icon>) {
  return <Icon component={CarSvg} {...props} />;
}
